// Profile-visible playlists verified in Music; public Apple Music metadata snapshot.
// Captured 2026-10-06. Tracks contain the first 15 public entries (or all when fewer).
const musicPlaylists = [
  {
    "key": "michael",
    "title": "Michael",
    "color": "#f18a43",
    "size": 60,
    "src": "https://embed.music.apple.com/us/playlist/michael/pl.u-YGB2FD2PrGE",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-001-Image000001/v4/63/62/91/636291e2-d9f1-1a68-6dba-01acae366096/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "269573478",
        "title": "The Lady in My Life",
        "artist": "Michael Jackson",
        "album": "Thriller",
        "duration": "4:58",
        "url": "https://music.apple.com/us/album/the-lady-in-my-life/269572838?i=269573478"
      },
      {
        "id": "559334754",
        "title": "Liberian Girl (2012 Remastered Version)",
        "artist": "Michael Jackson",
        "album": "Bad",
        "duration": "3:52",
        "url": "https://music.apple.com/us/album/liberian-girl-2012-remastered-version/559334659?i=559334754"
      },
      {
        "id": "159294296",
        "title": "P.Y.T. (Pretty Young Thing)",
        "artist": "Michael Jackson",
        "album": "The Essential Michael Jackson",
        "duration": "3:59",
        "url": "https://music.apple.com/us/album/p-y-t-pretty-young-thing/159292399?i=159294296"
      },
      {
        "id": "269573364",
        "title": "Billie Jean",
        "artist": "Michael Jackson",
        "album": "Thriller",
        "duration": "4:53",
        "url": "https://music.apple.com/us/album/billie-jean/269572838?i=269573364"
      },
      {
        "id": "186166428",
        "title": "Get on the Floor",
        "artist": "Michael Jackson",
        "album": "Off the Wall",
        "duration": "4:37",
        "url": "https://music.apple.com/us/album/get-on-the-floor/186166282?i=186166428"
      },
      {
        "id": "1440912116",
        "title": "I'll Be There",
        "artist": "Jackson 5",
        "album": "The Ultimate Collection",
        "duration": "3:57",
        "url": "https://music.apple.com/us/album/ill-be-there/1440912101?i=1440912116"
      },
      {
        "id": "186166358",
        "title": "Rock with You (Single Version)",
        "artist": "Michael Jackson",
        "album": "Off the Wall",
        "duration": "3:39",
        "url": "https://music.apple.com/us/album/rock-with-you-single-version/186166282?i=186166358"
      },
      {
        "id": "322847187",
        "title": "Remember the Time",
        "artist": "Michael Jackson",
        "album": "Dangerous",
        "duration": "4:00",
        "url": "https://music.apple.com/us/album/remember-the-time/322847038?i=322847187"
      },
      {
        "id": "551515762",
        "title": "Dirty Diana (2012 Remaster)",
        "artist": "Michael Jackson",
        "album": "Bad 25th Anniversary",
        "duration": "4:40",
        "url": "https://music.apple.com/us/album/dirty-diana-2012-remaster/551515699?i=551515762"
      },
      {
        "id": "269573303",
        "title": "Thriller",
        "artist": "Michael Jackson",
        "album": "Thriller",
        "duration": "5:58",
        "url": "https://music.apple.com/us/album/thriller/269572838?i=269573303"
      },
      {
        "id": "1443222065",
        "title": "Who's Loving You",
        "artist": "Jackson 5",
        "album": "Diana Ross Presents the Jackson 5",
        "duration": "4:04",
        "url": "https://music.apple.com/us/album/whos-loving-you/1443221837?i=1443222065"
      },
      {
        "id": "269573042",
        "title": "Baby Be Mine",
        "artist": "Michael Jackson",
        "album": "Thriller",
        "duration": "4:20",
        "url": "https://music.apple.com/us/album/baby-be-mine/269572838?i=269573042"
      },
      {
        "id": "186166292",
        "title": "Don't Stop 'Til You Get Enough",
        "artist": "Michael Jackson",
        "album": "Off the Wall",
        "duration": "6:04",
        "url": "https://music.apple.com/us/album/dont-stop-til-you-get-enough/186166282?i=186166292"
      },
      {
        "id": "1443222051",
        "title": "I Want You Back",
        "artist": "Jackson 5",
        "album": "Diana Ross Presents the Jackson 5",
        "duration": "3:01",
        "url": "https://music.apple.com/us/album/i-want-you-back/1443221837?i=1443222051"
      },
      {
        "id": "269573341",
        "title": "Beat It",
        "artist": "Michael Jackson",
        "album": "Thriller",
        "duration": "4:18",
        "url": "https://music.apple.com/us/album/beat-it/269572838?i=269573341"
      }
    ]
  },
  {
    "key": "top10",
    "title": "Top 10 Songs of All Time",
    "color": "#55bfdf",
    "size": 64,
    "src": "https://embed.music.apple.com/us/playlist/top-10-songs-of-all-time/pl.u-AZ5aTlm28oZ",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/gen/400x400AM.PDCXS11.jpg?c1=FFFFFF&c2=FF8080&c3=7CF4FF&c4=004040&signature=1769a3757c39c8534527f114a6256be160b10c683c2b827ae2a2bb98327bedfb&t=VG9wIDEwIFNvbmdzIG9mIEFsbCBUaW1l&tc=000000&vkey=1",
    "tracks": [
      {
        "id": "269573364",
        "title": "Billie Jean",
        "artist": "Michael Jackson",
        "album": "Thriller",
        "duration": "4:53",
        "url": "https://music.apple.com/us/album/billie-jean/269572838?i=269573364"
      },
      {
        "id": "193085066",
        "title": "Careless Whisper",
        "artist": "George Michael",
        "album": "Make It Big",
        "duration": "6:32",
        "url": "https://music.apple.com/us/album/careless-whisper/193084944?i=193085066"
      },
      {
        "id": "1440775140",
        "title": "Give It to Me Baby",
        "artist": "Rick James",
        "album": "20th Century Masters - The Millennium Collection: The Best of Rick James",
        "duration": "4:06",
        "url": "https://music.apple.com/us/album/give-it-to-me-baby/1440774926?i=1440775140"
      },
      {
        "id": "394919855",
        "title": "I'm Your Baby Tonight",
        "artist": "Whitney Houston",
        "album": "I'm Your Baby Tonight",
        "duration": "4:59",
        "url": "https://music.apple.com/us/album/im-your-baby-tonight/394919823?i=394919855"
      },
      {
        "id": "333592942",
        "title": "He's the Greatest Dancer (1995 Remaster)",
        "artist": "Sister Sledge",
        "album": "We Are Family (1995 Remaster)",
        "duration": "6:15",
        "url": "https://music.apple.com/us/album/hes-the-greatest-dancer-1995-remaster/333589490?i=333592942"
      },
      {
        "id": "269573303",
        "title": "Thriller",
        "artist": "Michael Jackson",
        "album": "Thriller",
        "duration": "5:58",
        "url": "https://music.apple.com/us/album/thriller/269572838?i=269573303"
      },
      {
        "id": "1440891494",
        "title": "Passionfruit",
        "artist": "Drake",
        "album": "More Life",
        "duration": "4:58",
        "url": "https://music.apple.com/us/album/passionfruit/1440890708?i=1440891494"
      },
      {
        "id": "1440773772",
        "title": "Roni",
        "artist": "Bobby Brown",
        "album": "Don't Be Cruel",
        "duration": "5:58",
        "url": "https://music.apple.com/us/album/roni/1440773569?i=1440773772"
      },
      {
        "id": "1490914106",
        "title": "Come On Eileen",
        "artist": "Dexys Midnight Runners",
        "album": "Too Rye Ay",
        "duration": "4:47",
        "url": "https://music.apple.com/us/album/come-on-eileen/1490913660?i=1490914106"
      },
      {
        "id": "532975795",
        "title": "Reasons",
        "artist": "Earth, Wind & Fire",
        "album": "That's the Way of the World",
        "duration": "4:59",
        "url": "https://music.apple.com/us/album/reasons/532975789?i=532975795"
      }
    ]
  },
  {
    "key": "thug",
    "title": "Thug",
    "color": "#cf6274",
    "size": 68,
    "src": "https://embed.music.apple.com/us/playlist/thug/pl.u-A4Jmulm28oZ",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-001-Image000001/v4/ef/2b/b5/ef2bb593-dd0d-74ae-d09f-323036b7eb5e/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "1842255390",
        "title": "Revenge (feat. Lil Gotit & 1300SAINT)",
        "artist": "Young Thug",
        "album": "UY SCUTI",
        "duration": "3:25",
        "url": "https://music.apple.com/us/album/revenge-feat-lil-gotit-1300saint/1842255351?i=1842255390"
      },
      {
        "id": "1564367310",
        "title": "Take It to Trial (feat. Yak Gotti)",
        "artist": "Young Stoner Life, Young Thug & Gunna",
        "album": "Slime Language 2 (Deluxe)",
        "duration": "2:50",
        "url": "https://music.apple.com/us/album/take-it-to-trial-feat-yak-gotti/1564367123?i=1564367310"
      },
      {
        "id": "1146718345",
        "title": "Wyclef Jean",
        "artist": "Young Thug",
        "album": "JEFFERY",
        "duration": "3:56",
        "url": "https://music.apple.com/us/album/wyclef-jean/1146718343?i=1146718345"
      },
      {
        "id": "986012229",
        "title": "Dome (feat. Duke)",
        "artist": "Young Thug",
        "album": "Barter 6",
        "duration": "3:51",
        "url": "https://music.apple.com/us/album/dome-feat-duke/986011611?i=986012229"
      },
      {
        "id": "1694433578",
        "title": "Wit Da Racks (feat. 21 Savage, Travis Scott & Yak Gotti)",
        "artist": "Young Thug",
        "album": "BUSINESS IS BUSINESS (Metro's Version)",
        "duration": "3:46",
        "url": "https://music.apple.com/us/album/wit-da-racks-feat-21-savage-travis-scott-yak-gotti/1694433081?i=1694433578"
      },
      {
        "id": "1492389920",
        "title": "Jumped Out the Window",
        "artist": "Young Thug",
        "album": "So Much Fun (Deluxe)",
        "duration": "3:24",
        "url": "https://music.apple.com/us/album/jumped-out-the-window/1492389435?i=1492389920"
      },
      {
        "id": "1694433433",
        "title": "Oh U Went (feat. Drake)",
        "artist": "Young Thug",
        "album": "BUSINESS IS BUSINESS (Metro's Version)",
        "duration": "3:05",
        "url": "https://music.apple.com/us/album/oh-u-went-feat-drake/1694433081?i=1694433433"
      },
      {
        "id": "1564367124",
        "title": "Slam the Door",
        "artist": "Young Stoner Life, Young Thug & Gunna",
        "album": "Slime Language 2 (Deluxe)",
        "duration": "3:08",
        "url": "https://music.apple.com/us/album/slam-the-door/1564367123?i=1564367124"
      },
      {
        "id": "1452313875",
        "title": "3 Headed Snake (feat. Young Thug)",
        "artist": "Gunna",
        "album": "Drip or Drown 2",
        "duration": "4:01",
        "url": "https://music.apple.com/us/album/3-headed-snake-feat-young-thug/1452313862?i=1452313875"
      },
      {
        "id": "1298483109",
        "title": "200",
        "artist": "Future & Young Thug",
        "album": "SUPER SLIMEY",
        "duration": "2:26",
        "url": "https://music.apple.com/us/album/200/1298483081?i=1298483109"
      },
      {
        "id": "1095065284",
        "title": "Problem",
        "artist": "Young Thug",
        "album": "Slime Season 3",
        "duration": "4:01",
        "url": "https://music.apple.com/us/album/problem/1095065232?i=1095065284"
      },
      {
        "id": "1492389926",
        "title": "Big Tipper (feat. Lil Keed)",
        "artist": "Young Thug",
        "album": "So Much Fun (Deluxe)",
        "duration": "3:43",
        "url": "https://music.apple.com/us/album/big-tipper-feat-lil-keed/1492389435?i=1492389926"
      },
      {
        "id": "1773169242",
        "title": "Power",
        "artist": "Young Thug",
        "album": "Slime Season",
        "duration": "3:15",
        "url": "https://music.apple.com/us/album/power/1773169057?i=1773169242"
      },
      {
        "id": "1564367292",
        "title": "Came and Saw (feat. Rowdy Rebel)",
        "artist": "Young Stoner Life & Young Thug",
        "album": "Slime Language 2 (Deluxe)",
        "duration": "2:54",
        "url": "https://music.apple.com/us/album/came-and-saw-feat-rowdy-rebel/1564367123?i=1564367292"
      },
      {
        "id": "1298483096",
        "title": "Three",
        "artist": "Future & Young Thug",
        "album": "SUPER SLIMEY",
        "duration": "2:39",
        "url": "https://music.apple.com/us/album/three/1298483081?i=1298483096"
      }
    ]
  },
  {
    "key": "hm",
    "title": "H&M",
    "color": "#8cc7a8",
    "size": 60,
    "src": "https://embed.music.apple.com/us/playlist/h-m/pl.u-PPKVuyKL02E",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/gen/400x400AM.PDCXS13.jpg?c1=9DF2B3&c2=40FF9F&c3=00B30B&c4=2C4000&signature=8e6364c8b548f5f5bc38d30e44e565e7d3f493ffc1c237a6aa94508ce2973a07&t=SCZN&tc=000000&vkey=1",
    "tracks": [
      {
        "id": "1668868380",
        "title": "Pearls",
        "artist": "Jessie Ware",
        "album": "That! Feels Good!",
        "duration": "4:03",
        "url": "https://music.apple.com/us/album/pearls/1668868373?i=1668868380"
      },
      {
        "id": "1842897454",
        "title": "The Fate of Ophelia",
        "artist": "Taylor Swift",
        "album": "The Life of a Showgirl",
        "duration": "3:46",
        "url": "https://music.apple.com/us/album/the-fate-of-ophelia/1842897453?i=1842897454"
      },
      {
        "id": "535572389",
        "title": "Hot Together",
        "artist": "The Pointer Sisters",
        "album": "Hot Together",
        "duration": "4:13",
        "url": "https://music.apple.com/us/album/hot-together/535572028?i=535572389"
      },
      {
        "id": "1680156049",
        "title": "Begin Again (Single Edit)",
        "artist": "Jessie Ware",
        "album": "Begin Again (Single Edit) - Single",
        "duration": "3:37",
        "url": "https://music.apple.com/us/album/begin-again-single-edit/1680156046?i=1680156049"
      },
      {
        "id": "1803412611",
        "title": "Azizam",
        "artist": "Ed Sheeran",
        "album": "Azizam - Single",
        "duration": "2:42",
        "url": "https://music.apple.com/us/album/azizam/1803412491?i=1803412611"
      },
      {
        "id": "1772394889",
        "title": "PUSH 2 START",
        "artist": "Tyla",
        "album": "TYLA +",
        "duration": "2:36",
        "url": "https://music.apple.com/us/album/push-2-start/1772394609?i=1772394889"
      },
      {
        "id": "1734980440",
        "title": "Whatcha Doing",
        "artist": "Dua Lipa",
        "album": "Radical Optimism",
        "duration": "3:18",
        "url": "https://music.apple.com/us/album/whatcha-doing/1734980417?i=1734980440"
      },
      {
        "id": "1499019279",
        "title": "Spotlight (Edit)",
        "artist": "Jessie Ware",
        "album": "Spotlight (Edit) - Single",
        "duration": "4:12",
        "url": "https://music.apple.com/us/album/spotlight-edit/1499019096?i=1499019279"
      },
      {
        "id": "1752543765",
        "title": "the boy is mine (Remix)",
        "artist": "Ariana Grande, Brandy & Monica",
        "album": "the boy is mine (Remix) - Single",
        "duration": "3:33",
        "url": "https://music.apple.com/us/album/the-boy-is-mine-remix/1752543759?i=1752543765"
      },
      {
        "id": "1734980420",
        "title": "Houdini",
        "artist": "Dua Lipa",
        "album": "Radical Optimism",
        "duration": "3:05",
        "url": "https://music.apple.com/us/album/houdini/1734980417?i=1734980420"
      },
      {
        "id": "1724459297",
        "title": "Dance You Outta My Head",
        "artist": "Cat Janice",
        "album": "Dance You Outta My Head - Single",
        "duration": "3:22",
        "url": "https://music.apple.com/us/album/dance-you-outta-my-head/1724458876?i=1724459297"
      },
      {
        "id": "1676555853",
        "title": "Feather",
        "artist": "Sabrina Carpenter",
        "album": "emails i can\u2019t send fwd:",
        "duration": "3:05",
        "url": "https://music.apple.com/us/album/feather/1676555529?i=1676555853"
      },
      {
        "id": "1603171533",
        "title": "Sacrifice",
        "artist": "The Weeknd",
        "album": "Dawn FM",
        "duration": "3:08",
        "url": "https://music.apple.com/us/album/sacrifice/1603171516?i=1603171533"
      },
      {
        "id": "1869414366",
        "title": "Mon Amour",
        "artist": "Jessie Ware",
        "album": "Superbloom",
        "duration": "3:45",
        "url": "https://music.apple.com/us/album/mon-amour/1869414259?i=1869414366"
      },
      {
        "id": "1792667018",
        "title": "LoveDrug",
        "artist": "Lady Gaga",
        "album": "MAYHEM",
        "duration": "3:13",
        "url": "https://music.apple.com/us/album/lovedrug/1792666546?i=1792667018"
      }
    ]
  },
  {
    "key": "weeknd",
    "title": "The Weeknd",
    "color": "#729ddb",
    "size": 64,
    "src": "https://embed.music.apple.com/us/playlist/the-weeknd/pl.u-BpJesRv1kPN",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-035-Image000001/v4/33/9b/8b/339b8b48-aae5-5c0f-df44-9f9b3e39ad5e/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "1714909006",
        "title": "The Zone (feat. Drake)",
        "artist": "The Weeknd",
        "album": "Trilogy",
        "duration": "6:58",
        "url": "https://music.apple.com/us/album/the-zone-feat-drake/1714908584?i=1714909006"
      },
      {
        "id": "1603171893",
        "title": "Is There Someone Else?",
        "artist": "The Weeknd",
        "album": "Dawn FM",
        "duration": "3:19",
        "url": "https://music.apple.com/us/album/is-there-someone-else/1603171516?i=1603171893"
      },
      {
        "id": "1579255925",
        "title": "The Birds, Pt. 2 (Original)",
        "artist": "The Weeknd",
        "album": "Thursday (Original)",
        "duration": "5:50",
        "url": "https://music.apple.com/us/album/the-birds-pt-2-original/1579255902?i=1579255925"
      },
      {
        "id": "1793654634",
        "title": "Enjoy The Show",
        "artist": "The Weeknd & Future",
        "album": "Hurry Up Tomorrow",
        "duration": "5:01",
        "url": "https://music.apple.com/us/album/enjoy-the-show/1793654348?i=1793654634"
      },
      {
        "id": "1440826376",
        "title": "Tell Your Friends",
        "artist": "The Weeknd",
        "album": "Beauty Behind the Madness",
        "duration": "5:34",
        "url": "https://music.apple.com/us/album/tell-your-friends/1440826239?i=1440826376"
      },
      {
        "id": "1673432343",
        "title": "Die For You (Remix)",
        "artist": "The Weeknd & Ariana Grande",
        "album": "Die For You (Remix) - Single",
        "duration": "3:52",
        "url": "https://music.apple.com/us/album/die-for-you-remix/1673432330?i=1673432343"
      },
      {
        "id": "1558942156",
        "title": "House of Balloons / Glass Table Girls (Original)",
        "artist": "The Weeknd",
        "album": "House of Balloons (Original)",
        "duration": "6:47",
        "url": "https://music.apple.com/us/album/house-of-balloons-glass-table-girls-original/1558941834?i=1558942156"
      },
      {
        "id": "1440826588",
        "title": "Prisoner (feat. Lana Del Rey)",
        "artist": "The Weeknd",
        "album": "Beauty Behind the Madness",
        "duration": "4:34",
        "url": "https://music.apple.com/us/album/prisoner-feat-lana-del-rey/1440826239?i=1440826588"
      },
      {
        "id": "1793654349",
        "title": "Wake Me Up",
        "artist": "The Weeknd & Justice",
        "album": "Hurry Up Tomorrow",
        "duration": "5:08",
        "url": "https://music.apple.com/us/album/wake-me-up/1793654348?i=1793654349"
      },
      {
        "id": "1615128020",
        "title": "Blinding Lights",
        "artist": "The Weeknd",
        "album": "After Hours (Deluxe Video Album)",
        "duration": "3:20",
        "url": "https://music.apple.com/us/album/blinding-lights/1615127777?i=1615128020"
      },
      {
        "id": "1440826386",
        "title": "Acquainted",
        "artist": "The Weeknd",
        "album": "Beauty Behind the Madness",
        "duration": "5:48",
        "url": "https://music.apple.com/us/album/acquainted/1440826239?i=1440826386"
      },
      {
        "id": "1421243049",
        "title": "WAKE UP",
        "artist": "Travis Scott",
        "album": "ASTROWORLD",
        "duration": "3:51",
        "url": "https://music.apple.com/us/album/wake-up/1421241217?i=1421243049"
      },
      {
        "id": "1793654358",
        "title": "Open Hearts",
        "artist": "The Weeknd",
        "album": "Hurry Up Tomorrow",
        "duration": "3:54",
        "url": "https://music.apple.com/us/album/open-hearts/1793654348?i=1793654358"
      },
      {
        "id": "1440826580",
        "title": "In the Night",
        "artist": "The Weeknd",
        "album": "Beauty Behind the Madness",
        "duration": "3:55",
        "url": "https://music.apple.com/us/album/in-the-night/1440826239?i=1440826580"
      },
      {
        "id": "1499386250",
        "title": "Escape From LA",
        "artist": "The Weeknd",
        "album": "After Hours",
        "duration": "5:55",
        "url": "https://music.apple.com/us/album/escape-from-la/1499385848?i=1499386250"
      }
    ]
  },
  {
    "key": "must-hear",
    "title": "Songs you need to hear at least once",
    "color": "#b2967a",
    "size": 68,
    "src": "https://embed.music.apple.com/us/playlist/songs-you-need-to-hear-at-least-once/pl.u-6Aa8cKABzjD",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/gen/400x400AM.PDCXS13.jpg?c1=9DCEF2&c2=FF4049&c3=B30007&c4=401600&signature=af45c004a9ff27730b1b8178bd4b64be637e5d58794b7ca327babc15bbcb0826&t=U29uZ3MgeW91IG5lZWQgdG8gaGVhciBhdCBsZWFzdCBvbmNl&tc=000000&vkey=1",
    "tracks": [
      {
        "id": "1563411095",
        "title": "Spotlight",
        "artist": "Jessie Ware",
        "album": "What's Your Pleasure? (The Platinum Pleasure Edition)",
        "duration": "5:31",
        "url": "https://music.apple.com/us/album/spotlight/1563411093?i=1563411095"
      },
      {
        "id": "1440934029",
        "title": "Woo",
        "artist": "Rihanna",
        "album": "ANTI (Deluxe)",
        "duration": "3:55",
        "url": "https://music.apple.com/us/album/woo/1440933869?i=1440934029"
      },
      {
        "id": "1836226730",
        "title": "Dracula",
        "artist": "Tame Impala",
        "album": "Deadbeat",
        "duration": "3:25",
        "url": "https://music.apple.com/us/album/dracula/1836226516?i=1836226730"
      },
      {
        "id": "1774384679",
        "title": "ORCHESTRAT\u00cb",
        "artist": "Yeat",
        "album": "LYFESTYLE",
        "duration": "2:53",
        "url": "https://music.apple.com/us/album/orchestrat%C3%AB/1774384537?i=1774384679"
      },
      {
        "id": "1588425950",
        "title": "Keep Moving",
        "artist": "Jungle",
        "album": "Loving in Stereo",
        "duration": "4:00",
        "url": "https://music.apple.com/us/album/keep-moving/1588425938?i=1588425950"
      },
      {
        "id": "1836226731",
        "title": "Loser",
        "artist": "Tame Impala",
        "album": "Deadbeat",
        "duration": "3:43",
        "url": "https://music.apple.com/us/album/loser/1836226516?i=1836226731"
      },
      {
        "id": "1443751535",
        "title": "In My House",
        "artist": "Mary Jane Girls",
        "album": "Only Four You",
        "duration": "5:02",
        "url": "https://music.apple.com/us/album/in-my-house/1443751372?i=1443751535"
      },
      {
        "id": "1544308722",
        "title": "Adore (2020 Remaster)",
        "artist": "Prince",
        "album": "Sign O' The Times (Super Deluxe Edition)",
        "duration": "6:34",
        "url": "https://music.apple.com/us/album/adore-2020-remaster/1544308646?i=1544308722"
      },
      {
        "id": "1440843916",
        "title": "Dangerous Woman",
        "artist": "Ariana Grande",
        "album": "Dangerous Woman",
        "duration": "3:55",
        "url": "https://music.apple.com/us/album/dangerous-woman/1440843597?i=1440843916"
      },
      {
        "id": "1441844540",
        "title": "Who Do We Think We Are (feat. Rick Ross)",
        "artist": "John Legend",
        "album": "Love in the Future (Expanded Edition)",
        "duration": "4:52",
        "url": "https://music.apple.com/us/album/who-do-we-think-we-are-feat-rick-ross/1441844369?i=1441844540"
      },
      {
        "id": "1836226518",
        "title": "My Old Ways",
        "artist": "Tame Impala",
        "album": "Deadbeat",
        "duration": "4:58",
        "url": "https://music.apple.com/us/album/my-old-ways/1836226516?i=1836226518"
      },
      {
        "id": "1442286249",
        "title": "Man Down",
        "artist": "Rihanna",
        "album": "Loud",
        "duration": "4:27",
        "url": "https://music.apple.com/us/album/man-down/1442286224?i=1442286249"
      },
      {
        "id": "683346494",
        "title": "Come a Little Closer",
        "artist": "Cage the Elephant",
        "album": "Melophobia",
        "duration": "3:49",
        "url": "https://music.apple.com/us/album/come-a-little-closer/683346293?i=683346494"
      },
      {
        "id": "1668868381",
        "title": "Hello Love",
        "artist": "Jessie Ware",
        "album": "That! Feels Good!",
        "duration": "4:42",
        "url": "https://music.apple.com/us/album/hello-love/1668868373?i=1668868381"
      },
      {
        "id": "1775597791",
        "title": "Fame",
        "artist": "Irene Cara",
        "album": "Flashdance - EP",
        "duration": "4:02",
        "url": "https://music.apple.com/us/album/fame/1775597789?i=1775597791"
      }
    ]
  },
  {
    "key": "the-boy",
    "title": "The Boy",
    "color": "#e6bb72",
    "size": 60,
    "src": "https://embed.music.apple.com/us/playlist/the-boy/pl.u-lx4JTP2ja3D",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-001-Image000001/v4/6f/cd/0d/6fcd0d4a-18ac-8d5c-2351-382ef166b6d6/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "6769568610",
        "title": "2 Hard 4 The Radio",
        "artist": "Drake",
        "album": "ICEMAN",
        "duration": "3:03",
        "url": "https://music.apple.com/us/album/2-hard-4-the-radio/6769568449?i=6769568610"
      },
      {
        "id": "1838368566",
        "title": "DOG HOUSE",
        "artist": "Drake, Julia Wolf & Yeat",
        "album": "DOG HOUSE - Single",
        "duration": "3:10",
        "url": "https://music.apple.com/us/album/dog-house/1838368565?i=1838368566"
      },
      {
        "id": "6769568597",
        "title": "Ran To Atlanta",
        "artist": "Drake, Future & Molly Santana",
        "album": "ICEMAN",
        "duration": "4:07",
        "url": "https://music.apple.com/us/album/ran-to-atlanta/6769568449?i=6769568597"
      },
      {
        "id": "6769568596",
        "title": "Janice STFU",
        "artist": "Drake",
        "album": "ICEMAN",
        "duration": "3:57",
        "url": "https://music.apple.com/us/album/janice-stfu/6769568449?i=6769568596"
      },
      {
        "id": "1699712649",
        "title": "MELTDOWN (feat. Drake)",
        "artist": "Travis Scott",
        "album": "UTOPIA",
        "duration": "4:06",
        "url": "https://music.apple.com/us/album/meltdown-feat-drake/1699712635?i=1699712649"
      },
      {
        "id": "1437955727",
        "title": "Never Recover",
        "artist": "Lil Baby, Gunna & Drake",
        "album": "Drip Harder",
        "duration": "3:14",
        "url": "https://music.apple.com/us/album/never-recover/1437955279?i=1437955727"
      },
      {
        "id": "1571536894",
        "title": "Having Our Way (feat. Drake)",
        "artist": "Migos",
        "album": "Culture III",
        "duration": "4:38",
        "url": "https://music.apple.com/us/album/having-our-way-feat-drake/1571536878?i=1571536894"
      },
      {
        "id": "1710685970",
        "title": "Another Late Night (feat. Lil Yachty)",
        "artist": "Drake",
        "album": "For All The Dogs",
        "duration": "2:50",
        "url": "https://music.apple.com/us/album/another-late-night-feat-lil-yachty/1710685602?i=1710685970"
      },
      {
        "id": "1662166378",
        "title": "Over the Top (feat. Drake)",
        "artist": "Smiley",
        "album": "Over the Top (feat. Drake) - Single",
        "duration": "2:33",
        "url": "https://music.apple.com/us/album/over-the-top-feat-drake/1662166377?i=1662166378"
      },
      {
        "id": "1710685772",
        "title": "Fear Of Heights",
        "artist": "Drake",
        "album": "For All The Dogs",
        "duration": "2:35",
        "url": "https://music.apple.com/us/album/fear-of-heights/1710685602?i=1710685772"
      },
      {
        "id": "6769568603",
        "title": "National Treasures",
        "artist": "Drake",
        "album": "ICEMAN",
        "duration": "3:20",
        "url": "https://music.apple.com/us/album/national-treasures/6769568449?i=6769568603"
      },
      {
        "id": "1744684622",
        "title": "Family Matters",
        "artist": "Drake",
        "album": "Family Matters - Single",
        "duration": "7:36",
        "url": "https://music.apple.com/us/album/family-matters/1744684618?i=1744684622"
      },
      {
        "id": "1765842726",
        "title": "No Face",
        "artist": "Drake",
        "album": "No Face - Single",
        "duration": "2:17",
        "url": "https://music.apple.com/us/album/no-face/1765842724?i=1765842726"
      },
      {
        "id": "1710685783",
        "title": "First Person Shooter (feat. J. Cole)",
        "artist": "Drake",
        "album": "For All The Dogs",
        "duration": "4:07",
        "url": "https://music.apple.com/us/album/first-person-shooter-feat-j-cole/1710685602?i=1710685783"
      },
      {
        "id": "1440842655",
        "title": "Digital Dash",
        "artist": "Drake & Future",
        "album": "What a Time To Be Alive",
        "duration": "3:51",
        "url": "https://music.apple.com/us/album/digital-dash/1440842320?i=1440842655"
      }
    ]
  },
  {
    "key": "heartbreak-drake",
    "title": "Heartbreak Drake",
    "color": "#f18a43",
    "size": 64,
    "src": "https://embed.music.apple.com/us/playlist/heartbreak-drake/pl.u-lrE6IP2ja3D",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-001-Image000001/v4/9e/63/5e/9e635eda-e3da-7681-8f70-0930638fe35c/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "1511037390",
        "title": "Not You Too (feat. Chris Brown)",
        "artist": "Drake",
        "album": "Dark Lane Demo Tapes",
        "duration": "4:29",
        "url": "https://music.apple.com/us/album/not-you-too-feat-chris-brown/1511037323?i=1511037390"
      },
      {
        "id": "1630230784",
        "title": "Overdrive",
        "artist": "Drake",
        "album": "Honestly, Nevermind",
        "duration": "3:22",
        "url": "https://music.apple.com/us/album/overdrive/1630230040?i=1630230784"
      },
      {
        "id": "6769551479",
        "title": "White Bone",
        "artist": "Drake",
        "album": "HABIBTI",
        "duration": "4:57",
        "url": "https://music.apple.com/us/album/white-bone/6769551464?i=6769551479"
      },
      {
        "id": "1440840119",
        "title": "Madonna",
        "artist": "Drake",
        "album": "If You're Reading This It's Too Late",
        "duration": "2:57",
        "url": "https://music.apple.com/us/album/madonna/1440839718?i=1440840119"
      },
      {
        "id": "1796127371",
        "title": "RAINING IN HOUSTON",
        "artist": "Drake",
        "album": "$ome $exy $ongs 4 U",
        "duration": "4:04",
        "url": "https://music.apple.com/us/album/raining-in-houston/1796127242?i=1796127371"
      },
      {
        "id": "1716979253",
        "title": "Drew A Picasso",
        "artist": "Drake",
        "album": "For All The Dogs Scary Hours Edition",
        "duration": "4:22",
        "url": "https://music.apple.com/us/album/drew-a-picasso/1716979097?i=1716979253"
      },
      {
        "id": "1630230860",
        "title": "Down Hill",
        "artist": "Drake",
        "album": "Honestly, Nevermind",
        "duration": "4:10",
        "url": "https://music.apple.com/us/album/down-hill/1630230040?i=1630230860"
      },
      {
        "id": "1440841723",
        "title": "Summers Over Interlude",
        "artist": "Drake",
        "album": "Views",
        "duration": "1:46",
        "url": "https://music.apple.com/us/album/summers-over-interlude/1440841363?i=1440841723"
      },
      {
        "id": "1418213382",
        "title": "Jaded",
        "artist": "Drake",
        "album": "Scorpion",
        "duration": "4:22",
        "url": "https://music.apple.com/us/album/jaded/1418213110?i=1418213382"
      },
      {
        "id": "1584282037",
        "title": "Race My Mind",
        "artist": "Drake",
        "album": "Certified Lover Boy",
        "duration": "4:29",
        "url": "https://music.apple.com/us/album/race-my-mind/1584281467?i=1584282037"
      },
      {
        "id": "1440891494",
        "title": "Passionfruit",
        "artist": "Drake",
        "album": "More Life",
        "duration": "4:58",
        "url": "https://music.apple.com/us/album/passionfruit/1440890708?i=1440891494"
      },
      {
        "id": "1475177835",
        "title": "Girls Love Beyonc\u00e9 (feat. James Fauntleroy)",
        "artist": "Drake",
        "album": "Care Package",
        "duration": "3:45",
        "url": "https://music.apple.com/us/album/girls-love-beyonc%C3%A9-feat-james-fauntleroy/1475177816?i=1475177835"
      },
      {
        "id": "1440643127",
        "title": "Practice",
        "artist": "Drake",
        "album": "Take Care (Deluxe Version)",
        "duration": "3:57",
        "url": "https://music.apple.com/us/album/practice/1440642493?i=1440643127"
      },
      {
        "id": "1796127251",
        "title": "SOMETHING ABOUT YOU",
        "artist": "PARTYNEXTDOOR & Drake",
        "album": "$ome $exy $ongs 4 U",
        "duration": "3:38",
        "url": "https://music.apple.com/us/album/something-about-you/1796127242?i=1796127251"
      },
      {
        "id": "1716979402",
        "title": "Polar Opposites",
        "artist": "Drake",
        "album": "For All The Dogs Scary Hours Edition",
        "duration": "4:17",
        "url": "https://music.apple.com/us/album/polar-opposites/1716979097?i=1716979402"
      }
    ]
  },
  {
    "key": "r-and-b",
    "title": "R&B",
    "color": "#55bfdf",
    "size": 68,
    "src": "https://embed.music.apple.com/us/playlist/r-b/pl.u-PJV5TyKL02E",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/gen/400x400AM.PDCXS13.jpg?c1=F29DE1&c2=FF40D5&c3=B3008F&c4=000040&signature=4557fed6560b0dea918221155dcb8e8cdb1d1ac6933ceff12bcf4ccf14eca9b5&t=UiZC&tc=000000&vkey=1",
    "tracks": [
      {
        "id": "1727476315",
        "title": "Ready Or Not",
        "artist": "After 7",
        "album": "After7 (Expaded Edition)",
        "duration": "4:34",
        "url": "https://music.apple.com/us/album/ready-or-not/1727475733?i=1727476315"
      },
      {
        "id": "1611638078",
        "title": "After Last Night (with Thundercat & Bootsy Collins)",
        "artist": "Bruno Mars, Anderson .Paak & Silk Sonic",
        "album": "An Evening with Silk Sonic",
        "duration": "4:09",
        "url": "https://music.apple.com/us/album/after-last-night-with-thundercat-bootsy-collins/1611637679?i=1611638078"
      },
      {
        "id": "1794645210",
        "title": "Shirt",
        "artist": "SZA",
        "album": "SOS Deluxe: LANA",
        "duration": "3:01",
        "url": "https://music.apple.com/us/album/shirt/1794644675?i=1794645210"
      },
      {
        "id": "946559927",
        "title": "Lost Lover",
        "artist": "Tuxedo",
        "album": "Tuxedo",
        "duration": "3:33",
        "url": "https://music.apple.com/us/album/lost-lover/946559925?i=946559927"
      },
      {
        "id": "1415255607",
        "title": "The Way (feat. Mike Phillips)",
        "artist": "Jill Scott",
        "album": "Experience: Jill Scott 826+",
        "duration": "8:26",
        "url": "https://music.apple.com/us/album/the-way-feat-mike-phillips/1415255596?i=1415255607"
      },
      {
        "id": "1799080775",
        "title": "Get You (feat. Kali Uchis)",
        "artist": "Daniel Caesar",
        "album": "Freudian",
        "duration": "4:38",
        "url": "https://music.apple.com/us/album/get-you-feat-kali-uchis/1799080774?i=1799080775"
      },
      {
        "id": "290555301",
        "title": "Need U Bad",
        "artist": "Jazmine Sullivan",
        "album": "Fearless",
        "duration": "4:17",
        "url": "https://music.apple.com/us/album/need-u-bad/290555287?i=290555301"
      },
      {
        "id": "358467373",
        "title": "Don't Walk Away",
        "artist": "Jade",
        "album": "Jade to the Max",
        "duration": "3:36",
        "url": "https://music.apple.com/us/album/dont-walk-away/358467367?i=358467373"
      },
      {
        "id": "1670549671",
        "title": "CUFF IT (WETTER REMIX)",
        "artist": "Beyonc\u00e9",
        "album": "CUFF IT - Single",
        "duration": "4:09",
        "url": "https://music.apple.com/us/album/cuff-it-wetter-remix/1670549664?i=1670549671"
      },
      {
        "id": "254473944",
        "title": "All the Things (Your Man Won't Do)",
        "artist": "Joe",
        "album": "All That I Am",
        "duration": "6:20",
        "url": "https://music.apple.com/us/album/all-the-things-your-man-wont-do/254473943?i=254473944"
      },
      {
        "id": "1495633761",
        "title": "Moment",
        "artist": "Victoria Mon\u00e9t",
        "album": "Moment - Single",
        "duration": "2:59",
        "url": "https://music.apple.com/us/album/moment/1495633760?i=1495633761"
      },
      {
        "id": "357862565",
        "title": "All I Do Is Think of You",
        "artist": "Troop",
        "album": "Attitude",
        "duration": "3:49",
        "url": "https://music.apple.com/us/album/all-i-do-is-think-of-you/357862195?i=357862565"
      },
      {
        "id": "1444020824",
        "title": "Where My Girls At?",
        "artist": "702",
        "album": "702",
        "duration": "2:46",
        "url": "https://music.apple.com/us/album/where-my-girls-at/1444020307?i=1444020824"
      },
      {
        "id": "1444078783",
        "title": "Breakin' My Heart (Pretty Brown Eyes)",
        "artist": "Mint Condition",
        "album": "Meant to Be Mint",
        "duration": "5:56",
        "url": "https://music.apple.com/us/album/breakin-my-heart-pretty-brown-eyes/1444077897?i=1444078783"
      },
      {
        "id": "1590029546",
        "title": "No Love",
        "artist": "Summer Walker & SZA",
        "album": "Still Over It",
        "duration": "3:51",
        "url": "https://music.apple.com/us/album/no-love/1590029262?i=1590029546"
      }
    ]
  },
  {
    "key": "wunna",
    "title": "Wunna",
    "color": "#cf6274",
    "size": 60,
    "src": "https://embed.music.apple.com/us/playlist/wunna/pl.u-RgV5TeP3q1a",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-037-Image000001/v4/8d/d8/0b/8dd80be9-182a-67cb-82dd-bd0ce174305e/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "1744458265",
        "title": "hakuna matata",
        "artist": "Gunna",
        "album": "One of Wun",
        "duration": "2:07",
        "url": "https://music.apple.com/us/album/hakuna-matata/1744458034?i=1744458265"
      },
      {
        "id": "1537439945",
        "title": "Fox 5 (feat. Gunna)",
        "artist": "Lil Keed",
        "album": "Trapped on Cleveland 3 (Deluxe)",
        "duration": "3:48",
        "url": "https://music.apple.com/us/album/fox-5-feat-gunna/1537439511?i=1537439945"
      },
      {
        "id": "1524860637",
        "title": "ROCKSTAR BIKERS & CHAINS",
        "artist": "Gunna",
        "album": "WUNNA (Deluxe)",
        "duration": "2:09",
        "url": "https://music.apple.com/us/album/rockstar-bikers-chains/1524859942?i=1524860637"
      },
      {
        "id": "1774073509",
        "title": "him all along",
        "artist": "Gunna",
        "album": "him all along - Single",
        "duration": "2:38",
        "url": "https://music.apple.com/us/album/him-all-along/1774072803?i=1774073509"
      },
      {
        "id": "1830597945",
        "title": "again",
        "artist": "Gunna",
        "album": "The Last Wun",
        "duration": "3:00",
        "url": "https://music.apple.com/us/album/again/1830597627?i=1830597945"
      },
      {
        "id": "1692838504",
        "title": "born rich",
        "artist": "Gunna",
        "album": "a Gift & a Curse",
        "duration": "2:52",
        "url": "https://music.apple.com/us/album/born-rich/1692838126?i=1692838504"
      },
      {
        "id": "1830598160",
        "title": "won't stop",
        "artist": "Gunna",
        "album": "The Last Wun",
        "duration": "3:01",
        "url": "https://music.apple.com/us/album/wont-stop/1830597627?i=1830598160"
      },
      {
        "id": "1524860984",
        "title": "RELENTLESS (feat. Lil Uzi Vert)",
        "artist": "Gunna",
        "album": "WUNNA (Deluxe)",
        "duration": "2:48",
        "url": "https://music.apple.com/us/album/relentless-feat-lil-uzi-vert/1524859942?i=1524860984"
      },
      {
        "id": "1692838511",
        "title": "bread & butter",
        "artist": "Gunna",
        "album": "a Gift & a Curse",
        "duration": "3:46",
        "url": "https://music.apple.com/us/album/bread-butter/1692838126?i=1692838511"
      },
      {
        "id": "1830597933",
        "title": "gp",
        "artist": "Gunna",
        "album": "The Last Wun",
        "duration": "1:32",
        "url": "https://music.apple.com/us/album/gp/1830597627?i=1830597933"
      },
      {
        "id": "1692838512",
        "title": "turned your back",
        "artist": "Gunna",
        "album": "a Gift & a Curse",
        "duration": "4:03",
        "url": "https://music.apple.com/us/album/turned-your-back/1692838126?i=1692838512"
      },
      {
        "id": "1514490409",
        "title": "MET GALA",
        "artist": "Gunna",
        "album": "WUNNA",
        "duration": "2:29",
        "url": "https://music.apple.com/us/album/met-gala/1514490028?i=1514490409"
      },
      {
        "id": "1830597932",
        "title": "just say dat",
        "artist": "Gunna",
        "album": "The Last Wun",
        "duration": "2:03",
        "url": "https://music.apple.com/us/album/just-say-dat/1830597627?i=1830597932"
      },
      {
        "id": "1604945214",
        "title": "alotta cake",
        "artist": "Gunna",
        "album": "DRIP SEASON 4EVER",
        "duration": "3:13",
        "url": "https://music.apple.com/us/album/alotta-cake/1604944424?i=1604945214"
      },
      {
        "id": "1744458286",
        "title": "on one tonight",
        "artist": "Gunna",
        "album": "One of Wun",
        "duration": "1:30",
        "url": "https://music.apple.com/us/album/on-one-tonight/1744458034?i=1744458286"
      }
    ]
  },
  {
    "key": "funk",
    "title": "Funk",
    "color": "#8cc7a8",
    "size": 64,
    "src": "https://embed.music.apple.com/us/playlist/funk/pl.u-bxEGs39yJv8",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/gen/400x400AM.PDCXS13.jpg?c1=F2D49D&c2=FF5740&c3=B30A00&c4=400004&signature=dec34ee68373d8cf9f762248543eb9bd66d16571068c0546f3498e8d0afdf197&t=RnVuaw%3D%3D&tc=000000&vkey=1",
    "tracks": [
      {
        "id": "333592942",
        "title": "He's the Greatest Dancer (1995 Remaster)",
        "artist": "Sister Sledge",
        "album": "We Are Family (1995 Remaster)",
        "duration": "6:15",
        "url": "https://music.apple.com/us/album/hes-the-greatest-dancer-1995-remaster/333589490?i=333592942"
      },
      {
        "id": "6793735691",
        "title": "Bad Girls",
        "artist": "Donna Summer",
        "album": "Bad Girls",
        "duration": "4:55",
        "url": "https://music.apple.com/us/album/bad-girls/6793735689?i=6793735691"
      },
      {
        "id": "1423191437",
        "title": "Love You Inside Out",
        "artist": "Bee Gees",
        "album": "Spirits Having Flown",
        "duration": "4:11",
        "url": "https://music.apple.com/us/album/love-you-inside-out/1423191432?i=1423191437"
      },
      {
        "id": "292702272",
        "title": "It's a Love Thing",
        "artist": "The Whispers",
        "album": "Imagination",
        "duration": "5:10",
        "url": "https://music.apple.com/us/album/its-a-love-thing/292702264?i=292702272"
      },
      {
        "id": "394919855",
        "title": "I'm Your Baby Tonight",
        "artist": "Whitney Houston",
        "album": "I'm Your Baby Tonight",
        "duration": "4:59",
        "url": "https://music.apple.com/us/album/im-your-baby-tonight/394919823?i=394919855"
      },
      {
        "id": "431609124",
        "title": "Smooth Operator (Single Version)",
        "artist": "Sade",
        "album": "The Ultimate Collection (Remastered)",
        "duration": "4:16",
        "url": "https://music.apple.com/us/album/smooth-operator-single-version/431609122?i=431609124"
      },
      {
        "id": "1440773772",
        "title": "Roni",
        "artist": "Bobby Brown",
        "album": "Don't Be Cruel",
        "duration": "5:58",
        "url": "https://music.apple.com/us/album/roni/1440773569?i=1440773772"
      },
      {
        "id": "1054522875",
        "title": "Showdown",
        "artist": "Electric Light Orchestra",
        "album": "On the Third Day",
        "duration": "4:10",
        "url": "https://music.apple.com/us/album/showdown/1054522450?i=1054522875"
      },
      {
        "id": "186166428",
        "title": "Get on the Floor",
        "artist": "Michael Jackson",
        "album": "Off the Wall",
        "duration": "4:37",
        "url": "https://music.apple.com/us/album/get-on-the-floor/186166282?i=186166428"
      },
      {
        "id": "292707932",
        "title": "Fantastic Voyage",
        "artist": "Lakeside",
        "album": "Fantastic Voyage",
        "duration": "6:11",
        "url": "https://music.apple.com/us/album/fantastic-voyage/292707931?i=292707932"
      },
      {
        "id": "1443817879",
        "title": "I Like It",
        "artist": "DeBarge",
        "album": "All This Love",
        "duration": "4:39",
        "url": "https://music.apple.com/us/album/i-like-it/1443817875?i=1443817879"
      },
      {
        "id": "282544172",
        "title": "Rock Steady",
        "artist": "The Whispers",
        "album": "Greatest Hits",
        "duration": "5:07",
        "url": "https://music.apple.com/us/album/rock-steady/282544093?i=282544172"
      },
      {
        "id": "367515032",
        "title": "Happiness",
        "artist": "The Pointer Sisters",
        "album": "Energy (Expanded Edition)",
        "duration": "3:59",
        "url": "https://music.apple.com/us/album/happiness/367515004?i=367515032"
      },
      {
        "id": "6793735690",
        "title": "Hot Stuff",
        "artist": "Donna Summer",
        "album": "Bad Girls",
        "duration": "5:14",
        "url": "https://music.apple.com/us/album/hot-stuff/6793735689?i=6793735690"
      },
      {
        "id": "186166433",
        "title": "Off the Wall",
        "artist": "Michael Jackson",
        "album": "Off the Wall",
        "duration": "4:05",
        "url": "https://music.apple.com/us/album/off-the-wall/186166282?i=186166433"
      }
    ]
  },
  {
    "key": "jermaine",
    "title": "Jermaine",
    "color": "#729ddb",
    "size": 68,
    "src": "https://embed.music.apple.com/us/playlist/jermaine/pl.u-vvdMt8YzK6p",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-035-Image000001/v4/be/eb/28/beeb2895-1a4e-c3c1-64b4-14b6e68be322/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "1674976201",
        "title": "Adonis Interlude (The Montage)",
        "artist": "Dreamville & J. Cole",
        "album": "Creed III: The Soundtrack",
        "duration": "1:35",
        "url": "https://music.apple.com/us/album/adonis-interlude-the-montage/1674976186?i=1674976201"
      },
      {
        "id": "6788868507",
        "title": "Bronx Zoo Freestyle",
        "artist": "J. Cole",
        "album": "Birthday Blizzard \u201826 - EP",
        "duration": "3:05",
        "url": "https://music.apple.com/us/album/bronx-zoo-freestyle/6788868501?i=6788868507"
      },
      {
        "id": "1567422340",
        "title": "m y . l i f e",
        "artist": "J. Cole, 21 Savage & Morray",
        "album": "The Off-Season",
        "duration": "3:38",
        "url": "https://music.apple.com/us/album/m-y-l-i-f-e/1567421945?i=1567422340"
      },
      {
        "id": "1797876820",
        "title": "Port Antonio",
        "artist": "J. Cole",
        "album": "Port Antonio - Single",
        "duration": "5:16",
        "url": "https://music.apple.com/us/album/port-antonio/1797876818?i=1797876820"
      },
      {
        "id": "1607047464",
        "title": "Johnny P's Caddy",
        "artist": "Benny the Butcher & J. Cole",
        "album": "Johnny P's Caddy - Single",
        "duration": "3:45",
        "url": "https://music.apple.com/us/album/johnny-ps-caddy/1607047462?i=1607047464"
      },
      {
        "id": "1875080988",
        "title": "Bunce Road Blues",
        "artist": "J. Cole, Future & Tems",
        "album": "The Fall-Off",
        "duration": "5:10",
        "url": "https://music.apple.com/us/album/bunce-road-blues/1875080726?i=1875080988"
      },
      {
        "id": "1616999234",
        "title": "Stick (feat. Kenny Mason & Sheck Wes)",
        "artist": "Dreamville, JID & J. Cole",
        "album": "D-Day: A Gangsta Grillz Mixtape",
        "duration": "5:09",
        "url": "https://music.apple.com/us/album/stick-feat-kenny-mason-sheck-wes/1616999231?i=1616999234"
      },
      {
        "id": "1567422353",
        "title": "c l o s e",
        "artist": "J. Cole",
        "album": "The Off-Season",
        "duration": "2:48",
        "url": "https://music.apple.com/us/album/c-l-o-s-e/1567421945?i=1567422353"
      },
      {
        "id": "1875081099",
        "title": "Old Dog",
        "artist": "J. Cole & Petey Pablo",
        "album": "The Fall-Off",
        "duration": "3:22",
        "url": "https://music.apple.com/us/album/old-dog/1875080726?i=1875081099"
      },
      {
        "id": "6788868508",
        "title": "Golden Goose Freestyle",
        "artist": "J. Cole",
        "album": "Birthday Blizzard \u201826 - EP",
        "duration": "2:19",
        "url": "https://music.apple.com/us/album/golden-goose-freestyle/6788868501?i=6788868508"
      },
      {
        "id": "1600766221",
        "title": "Fire Squad",
        "artist": "J. Cole",
        "album": "2014 Forest Hills Drive",
        "duration": "4:48",
        "url": "https://music.apple.com/us/album/fire-squad/1600766204?i=1600766221"
      },
      {
        "id": "1875080994",
        "title": "The Let Out",
        "artist": "J. Cole",
        "album": "The Fall-Off",
        "duration": "4:14",
        "url": "https://music.apple.com/us/album/the-let-out/1875080726?i=1875080994"
      },
      {
        "id": "1451374598",
        "title": "Folgers Crystals",
        "artist": "J. Cole",
        "album": "Revenge of the Dreamers II",
        "duration": "2:23",
        "url": "https://music.apple.com/us/album/folgers-crystals/1451374593?i=1451374598"
      },
      {
        "id": "1600766436",
        "title": "No Role Modelz",
        "artist": "J. Cole",
        "album": "2014 Forest Hills Drive",
        "duration": "4:52",
        "url": "https://music.apple.com/us/album/no-role-modelz/1600766204?i=1600766436"
      },
      {
        "id": "6788868690",
        "title": "Winter Storm Freestyle",
        "artist": "J. Cole",
        "album": "Birthday Blizzard \u201826 - EP",
        "duration": "2:18",
        "url": "https://music.apple.com/us/album/winter-storm-freestyle/6788868501?i=6788868690"
      }
    ]
  },
  {
    "key": "gospel",
    "title": "Gospel",
    "color": "#b2967a",
    "size": 60,
    "src": "https://embed.music.apple.com/us/playlist/gospel/pl.u-b6y8t39yJv8",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/gen/400x400AM.PDCXS13.jpg?c1=F2D29D&c2=FFB840&c3=6B00B3&c4=000040&signature=2f3e4546dd3b5966624a6e283240f5bc0dbed7227679d8005d3216881415e9a4&t=R29zcGVs&tc=000000&vkey=1",
    "tracks": [
      {
        "id": "724558680",
        "title": "More Than Anything",
        "artist": "Lamar Campbell & Spirit Of Praise",
        "album": "When I Think About You",
        "duration": "6:36",
        "url": "https://music.apple.com/us/album/more-than-anything/724558045?i=724558680"
      },
      {
        "id": "308298823",
        "title": "When the Spirit of the Lord",
        "artist": "Fred Hammond & Radical for Christ",
        "album": "Spirit of David",
        "duration": "4:50",
        "url": "https://music.apple.com/us/album/when-the-spirit-of-the-lord/308298761?i=308298823"
      },
      {
        "id": "307496315",
        "title": "That's What I Believe (Live)",
        "artist": "Donnie McClurkin",
        "album": "Live In London and More...",
        "duration": "5:20",
        "url": "https://music.apple.com/us/album/thats-what-i-believe-live/307496311?i=307496315"
      },
      {
        "id": "374345777",
        "title": "Glorious",
        "artist": "Martha Munizzi",
        "album": "The Best Is Yet to Come",
        "duration": "5:58",
        "url": "https://music.apple.com/us/album/glorious/374345052?i=374345777"
      },
      {
        "id": "303191517",
        "title": "For Every Mountain",
        "artist": "Kurt Carr & The Kurt Carr Singers",
        "album": "The Very Best of Praise & Worship",
        "duration": "7:25",
        "url": "https://music.apple.com/us/album/for-every-mountain/303191377?i=303191517"
      },
      {
        "id": "400849633",
        "title": "Melodies from Heaven",
        "artist": "Kirk Franklin & The Family",
        "album": "Whatcha Lookin' 4",
        "duration": "4:34",
        "url": "https://music.apple.com/us/album/melodies-from-heaven/400849575?i=400849633"
      },
      {
        "id": "264090190",
        "title": "I Need You To Survive",
        "artist": "Hezekiah Walker & The Love Fellowship Choir",
        "album": "The Essential Hezekiah Walker",
        "duration": "7:31",
        "url": "https://music.apple.com/us/album/i-need-you-to-survive/264089896?i=264090190"
      },
      {
        "id": "1167825080",
        "title": "Safe In His Arms",
        "artist": "Rev. Milton Brunson & The Thompson Community Singers",
        "album": "The Ultimate Collection",
        "duration": "4:55",
        "url": "https://music.apple.com/us/album/safe-in-his-arms/1167825049?i=1167825080"
      },
      {
        "id": "539485388",
        "title": "His Eye Is On the Sparrow",
        "artist": "Whitney Houston",
        "album": "Sparkle (Original Motion Picture Soundtrack)",
        "duration": "3:33",
        "url": "https://music.apple.com/us/album/his-eye-is-on-the-sparrow/539484746?i=539485388"
      },
      {
        "id": "824331192",
        "title": "Healed",
        "artist": "Donald Lawrence",
        "album": "The Best of Donald Lawrence & Co.",
        "duration": "5:00",
        "url": "https://music.apple.com/us/album/healed/824331168?i=824331192"
      },
      {
        "id": "401042990",
        "title": "He'll Welcome Me (feat. John P. Kee)",
        "artist": "The New Life Community Choir",
        "album": "Show Up! (feat. John P. Kee)",
        "duration": "5:14",
        "url": "https://music.apple.com/us/album/hell-welcome-me-feat-john-p-kee/401042740?i=401042990"
      },
      {
        "id": "692903021",
        "title": "The Gift",
        "artist": "Donald Lawrence",
        "album": "Best For Last",
        "duration": "5:11",
        "url": "https://music.apple.com/us/album/the-gift/692903009?i=692903021"
      },
      {
        "id": "303172999",
        "title": "Let the Praise Begin",
        "artist": "Fred Hammond & Radical for Christ",
        "album": "Pages of Life - Chapters I & II",
        "duration": "5:21",
        "url": "https://music.apple.com/us/album/let-the-praise-begin/303172920?i=303172999"
      },
      {
        "id": "715593691",
        "title": "Encourage Yourself",
        "artist": "The Tri-City Singers",
        "album": "Grand Finale",
        "duration": "5:57",
        "url": "https://music.apple.com/us/album/encourage-yourself/715593513?i=715593691"
      },
      {
        "id": "303188202",
        "title": "In the Sanctuary",
        "artist": "Kurt Carr & The Kurt Carr Singers",
        "album": "Men of Gospo, Vol. 1",
        "duration": "6:06",
        "url": "https://music.apple.com/us/album/in-the-sanctuary/303188153?i=303188202"
      }
    ]
  },
  {
    "key": "pluto",
    "title": "Pluto \ud83e\ude90",
    "color": "#e6bb72",
    "size": 64,
    "src": "https://embed.music.apple.com/us/playlist/pluto/pl.u-le6AcP2ja3D",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-001-Image000001/v4/70/65/48/7065486c-ac6e-fb0e-532e-584ab7bdfcf2/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "1484890193",
        "title": "Gangland",
        "artist": "Future",
        "album": "Monster",
        "duration": "3:01",
        "url": "https://music.apple.com/us/album/gangland/1484889814?i=1484890193"
      },
      {
        "id": "1767830031",
        "title": "OATH",
        "artist": "Future",
        "album": "MIXTAPE PLUTO",
        "duration": "1:34",
        "url": "https://music.apple.com/us/album/oath/1767829562?i=1767830031"
      },
      {
        "id": "834632500",
        "title": "T-Shirt",
        "artist": "Future",
        "album": "Honest (Deluxe)",
        "duration": "3:35",
        "url": "https://music.apple.com/us/album/t-shirt/834632492?i=834632500"
      },
      {
        "id": "1448780187",
        "title": "Jumpin on a Jet",
        "artist": "Future",
        "album": "Future Hndrxx Presents: The WIZRD",
        "duration": "2:17",
        "url": "https://music.apple.com/us/album/jumpin-on-a-jet/1448780185?i=1448780187"
      },
      {
        "id": "1740864632",
        "title": "Drink N Dance",
        "artist": "Future & Metro Boomin",
        "album": "WE STILL DON'T TRUST YOU",
        "duration": "3:40",
        "url": "https://music.apple.com/us/album/drink-n-dance/1740864541?i=1740864632"
      },
      {
        "id": "6784327292",
        "title": "Konnichiwa",
        "artist": "Future",
        "album": "The Real Me",
        "duration": "2:33",
        "url": "https://music.apple.com/us/album/konnichiwa/6784327271?i=6784327292"
      },
      {
        "id": "1830374880",
        "title": "Partying & Drinking",
        "artist": "Metro Boomin, Waka Flocka Flame, Roscoe Dash, 21 Savage, Future & DJ Spinz",
        "album": "Metro Boomin Presents: A Futuristic Summa (Hosted by DJ Spinz)",
        "duration": "4:30",
        "url": "https://music.apple.com/us/album/partying-drinking/1830374691?i=1830374880"
      },
      {
        "id": "656704194",
        "title": "Body Party (Remix) [feat. Future & B.o.B]",
        "artist": "Ciara",
        "album": "Body Party (Remix) [feat. Future & B.o.B] - Single",
        "duration": "3:57",
        "url": "https://music.apple.com/us/album/body-party-remix-feat-future-b-o-b/656704109?i=656704194"
      },
      {
        "id": "1448780200",
        "title": "Unicorn Purp (feat. Young Thug & Gunna)",
        "artist": "Future",
        "album": "Future Hndrxx Presents: The WIZRD",
        "duration": "4:06",
        "url": "https://music.apple.com/us/album/unicorn-purp-feat-young-thug-gunna/1448780185?i=1448780200"
      },
      {
        "id": "6784327277",
        "title": "California Girls",
        "artist": "Future",
        "album": "The Real Me",
        "duration": "2:29",
        "url": "https://music.apple.com/us/album/california-girls/6784327271?i=6784327277"
      },
      {
        "id": "1767829866",
        "title": "BRAZZIER",
        "artist": "Future",
        "album": "MIXTAPE PLUTO",
        "duration": "3:08",
        "url": "https://music.apple.com/us/album/brazzier/1767829562?i=1767829866"
      },
      {
        "id": "1737150156",
        "title": "Type Shit",
        "artist": "Future, Metro Boomin, Travis Scott & Playboi Carti",
        "album": "WE DON'T TRUST YOU",
        "duration": "3:48",
        "url": "https://music.apple.com/us/album/type-shit/1737149923?i=1737150156"
      },
      {
        "id": "1407068967",
        "title": "31 DAYS",
        "artist": "Future",
        "album": "BEASTMODE 2",
        "duration": "4:00",
        "url": "https://music.apple.com/us/album/31-days/1407068657?i=1407068967"
      },
      {
        "id": "1835993249",
        "title": "Mr. Jones (feat. Future)",
        "artist": "Pop Smoke",
        "album": "Faith (Deluxe)",
        "duration": "3:34",
        "url": "https://music.apple.com/us/album/mr-jones-feat-future/1835992995?i=1835993249"
      },
      {
        "id": "6784327274",
        "title": "One Two",
        "artist": "Future",
        "album": "The Real Me",
        "duration": "1:59",
        "url": "https://music.apple.com/us/album/one-two/6784327271?i=6784327274"
      }
    ]
  },
  {
    "key": "workout",
    "title": "Did you workout today \ud83c\udfcb\ud83c\udffe",
    "color": "#f18a43",
    "size": 68,
    "src": "https://embed.music.apple.com/us/playlist/did-you-workout-today/pl.u-ZPZrtpY0rxm",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/gen/400x400AM.PDCXS13.jpg?c1=9DDDF2&c2=40B9FF&c3=0080B3&c4=001840&signature=eb9fc6ef6c4c78f36dac379e17da0ab9e4b058cf93c81bc80299562292f85bec&t=RGlkIHlvdSB3b3Jrb3V0IHRvZGF5IPCfj4vwn4--&tc=000000&vkey=1",
    "tracks": [
      {
        "id": "1636737356",
        "title": "It's All on You (feat. Kodak Black)",
        "artist": "Icewear Vezzo",
        "album": "It's All on You (feat. Kodak Black) - Single",
        "duration": "2:46",
        "url": "https://music.apple.com/us/album/its-all-on-you-feat-kodak-black/1636737353?i=1636737356"
      },
      {
        "id": "1724494865",
        "title": "dangerous",
        "artist": "21 Savage, Lil Durk & Metro Boomin",
        "album": "american dream",
        "duration": "4:25",
        "url": "https://music.apple.com/us/album/dangerous/1724494274?i=1724494865"
      },
      {
        "id": "1787098259",
        "title": "Houstatlantaville (feat. Lil Baby & Travis Scott)",
        "artist": "EST Gee",
        "album": "I Aint Feeling You",
        "duration": "3:25",
        "url": "https://music.apple.com/us/album/houstatlantaville-feat-lil-baby-travis-scott/1787098256?i=1787098259"
      },
      {
        "id": "1621803895",
        "title": "MASSAGING ME",
        "artist": "Future",
        "album": "I NEVER LIKED YOU",
        "duration": "1:46",
        "url": "https://music.apple.com/us/album/massaging-me/1621803882?i=1621803895"
      },
      {
        "id": "1637682501",
        "title": "Duntsane",
        "artist": "Young Nudy & BabyDrill",
        "album": "EA Monster",
        "duration": "3:11",
        "url": "https://music.apple.com/us/album/duntsane/1637681704?i=1637682501"
      },
      {
        "id": "1820015839",
        "title": "Bodies",
        "artist": "Offset & JID",
        "album": "Bodies - Single",
        "duration": "2:58",
        "url": "https://music.apple.com/us/album/bodies/1820015564?i=1820015839"
      },
      {
        "id": "1676156985",
        "title": "Hottest (feat. Big Sean)",
        "artist": "Lil Keed",
        "album": "Keed Talk To \u2018Em 2",
        "duration": "3:10",
        "url": "https://music.apple.com/us/album/hottest-feat-big-sean/1676156971?i=1676156985"
      },
      {
        "id": "1674872965",
        "title": "No Pole",
        "artist": "Don Toliver",
        "album": "Love Sick (Deluxe)",
        "duration": "3:07",
        "url": "https://music.apple.com/us/album/no-pole/1674872963?i=1674872965"
      },
      {
        "id": "1563323226",
        "title": "Came and Saw (feat. Rowdy Rebel)",
        "artist": "Young Stoner Life & Young Thug",
        "album": "Slime Language 2",
        "duration": "2:54",
        "url": "https://music.apple.com/us/album/came-and-saw-feat-rowdy-rebel/1563322881?i=1563323226"
      },
      {
        "id": "1674976201",
        "title": "Adonis Interlude (The Montage)",
        "artist": "Dreamville & J. Cole",
        "album": "Creed III: The Soundtrack",
        "duration": "1:35",
        "url": "https://music.apple.com/us/album/adonis-interlude-the-montage/1674976186?i=1674976201"
      },
      {
        "id": "1830591219",
        "title": "Set It Off",
        "artist": "Offset",
        "album": "KIARI",
        "duration": "1:40",
        "url": "https://music.apple.com/us/album/set-it-off/1830591137?i=1830591219"
      },
      {
        "id": "1643750656",
        "title": "Talk",
        "artist": "Yeat",
        "album": "Lyf\u00eb",
        "duration": "2:54",
        "url": "https://music.apple.com/us/album/talk/1643750030?i=1643750656"
      },
      {
        "id": "1648802658",
        "title": "Won\u2019t Step On Me",
        "artist": "YoungBoy Never Broke Again",
        "album": "3800 Degrees",
        "duration": "3:36",
        "url": "https://music.apple.com/us/album/wont-step-on-me/1648802294?i=1648802658"
      },
      {
        "id": "1599656847",
        "title": "Young Stunna",
        "artist": "YoungBoy Never Broke Again & Birdman",
        "album": "From The Bayou",
        "duration": "3:25",
        "url": "https://music.apple.com/us/album/young-stunna/1599656830?i=1599656847"
      },
      {
        "id": "1443677213",
        "title": "Crush A Lot",
        "artist": "Lil Baby",
        "album": "Street Gossip",
        "duration": "2:39",
        "url": "https://music.apple.com/us/album/crush-a-lot/1443676945?i=1443677213"
      }
    ]
  },
  {
    "key": "baby",
    "title": "Baby",
    "color": "#55bfdf",
    "size": 60,
    "src": "https://embed.music.apple.com/us/playlist/baby/pl.u-ZPrjCpY0rxm",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-001-Image000001/v4/08/cb/27/08cb27b7-438a-502b-6a16-f75e1af75422/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "6790569133",
        "title": "Dead Fresh",
        "artist": "Lil Baby",
        "album": "Dead Fresh - Single",
        "duration": "2:37",
        "url": "https://music.apple.com/us/album/dead-fresh/6790569132?i=6790569133"
      },
      {
        "id": "1787098259",
        "title": "Houstatlantaville (feat. Lil Baby & Travis Scott)",
        "artist": "EST Gee",
        "album": "I Aint Feeling You",
        "duration": "3:25",
        "url": "https://music.apple.com/us/album/houstatlantaville-feat-lil-baby-travis-scott/1787098256?i=1787098259"
      },
      {
        "id": "1569712093",
        "title": "2040",
        "artist": "Lil Baby & Lil Durk",
        "album": "The Voice of the Heroes",
        "duration": "3:12",
        "url": "https://music.apple.com/us/album/2040/1569712089?i=1569712093"
      },
      {
        "id": "1648587316",
        "title": "California Breeze",
        "artist": "Lil Baby",
        "album": "It's Only Me",
        "duration": "2:57",
        "url": "https://music.apple.com/us/album/california-breeze/1648587138?i=1648587316"
      },
      {
        "id": "1565443631",
        "title": "EVERY CHANCE I GET (feat. Lil Baby & Lil Durk)",
        "artist": "DJ Khaled",
        "album": "KHALED KHALED",
        "duration": "3:56",
        "url": "https://music.apple.com/us/album/every-chance-i-get-feat-lil-baby-lil-durk/1565443380?i=1565443631"
      },
      {
        "id": "1789237343",
        "title": "Dum, Dumb, and Dumber",
        "artist": "Lil Baby, Young Thug & Future",
        "album": "WHAM (Extended Version)",
        "duration": "3:47",
        "url": "https://music.apple.com/us/album/dum-dumb-and-dumber/1789237341?i=1789237343"
      },
      {
        "id": "1648587322",
        "title": "Never Hating",
        "artist": "Lil Baby & Young Thug",
        "album": "It's Only Me",
        "duration": "2:40",
        "url": "https://music.apple.com/us/album/never-hating/1648587138?i=1648587322"
      },
      {
        "id": "1510840889",
        "title": "Get Money",
        "artist": "Lil Baby",
        "album": "My Turn (Deluxe)",
        "duration": "2:47",
        "url": "https://music.apple.com/us/album/get-money/1510840178?i=1510840889"
      },
      {
        "id": "1384782409",
        "title": "Life Goes On (feat. Gunna & Lil Uzi Vert)",
        "artist": "Lil Baby",
        "album": "Harder Than Ever",
        "duration": "4:07",
        "url": "https://music.apple.com/us/album/life-goes-on-feat-gunna-lil-uzi-vert/1384782173?i=1384782409"
      },
      {
        "id": "1648587841",
        "title": "Shiest Talk (feat. Pooh Shiesty)",
        "artist": "Lil Baby",
        "album": "It's Only Me",
        "duration": "2:03",
        "url": "https://music.apple.com/us/album/shiest-talk-feat-pooh-shiesty/1648587138?i=1648587841"
      },
      {
        "id": "1487706295",
        "title": "How I Move (feat. Lil Baby)",
        "artist": "Flipp Dinero",
        "album": "How I Move (feat. Lil Baby) - Single",
        "duration": "3:44",
        "url": "https://music.apple.com/us/album/how-i-move-feat-lil-baby/1487706293?i=1487706295"
      },
      {
        "id": "1492418281",
        "title": "U Played (feat. Lil Baby)",
        "artist": "Moneybagg Yo",
        "album": "U Played (feat. Lil Baby) - Single",
        "duration": "2:44",
        "url": "https://music.apple.com/us/album/u-played-feat-lil-baby/1492418274?i=1492418281"
      },
      {
        "id": "1786672607",
        "title": "Listen Up",
        "artist": "Lil Baby",
        "album": "WHAM",
        "duration": "2:35",
        "url": "https://music.apple.com/us/album/listen-up/1786672591?i=1786672607"
      },
      {
        "id": "1510840890",
        "title": "We Paid",
        "artist": "Lil Baby & 42 Dugg",
        "album": "My Turn (Deluxe)",
        "duration": "3:01",
        "url": "https://music.apple.com/us/album/we-paid/1510840178?i=1510840890"
      },
      {
        "id": "1428235415",
        "title": "Chanel (Go Get It) [feat. Gunna & Lil Baby]",
        "artist": "Young Thug & Young Stoner Life",
        "album": "Slime Language",
        "duration": "3:21",
        "url": "https://music.apple.com/us/album/chanel-go-get-it-feat-gunna-lil-baby/1428233006?i=1428235415"
      }
    ]
  },
  {
    "key": "white-folks",
    "title": "White Folks",
    "color": "#cf6274",
    "size": 64,
    "src": "https://embed.music.apple.com/us/playlist/white-folks/pl.u-b697u39yJv8",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/gen/400x400AM.PDCXS13.jpg?c1=F2E69D&c2=FF4840&c3=B37D00&c4=400011&signature=ec7859695369f927092846912c9fdc32dfd941c7d2c0dcc1eae01008fb30e9fb&t=V2hpdGUgRm9sa3M%3D&tc=000000&vkey=1",
    "tracks": [
      {
        "id": "697669247",
        "title": "Devil Woman",
        "artist": "Cliff Richard",
        "album": "I'm Nearly Famous (Remastered)",
        "duration": "3:35",
        "url": "https://music.apple.com/us/album/devil-woman/697669239?i=697669247"
      },
      {
        "id": "1054522875",
        "title": "Showdown",
        "artist": "Electric Light Orchestra",
        "album": "On the Third Day",
        "duration": "4:10",
        "url": "https://music.apple.com/us/album/showdown/1054522450?i=1054522875"
      },
      {
        "id": "1443129077",
        "title": "Too Close",
        "artist": "Alex Clare",
        "album": "The Lateness Of The Hour",
        "duration": "4:16",
        "url": "https://music.apple.com/us/album/too-close/1443128938?i=1443129077"
      },
      {
        "id": "6781079518",
        "title": "Don't Stop Me Now",
        "artist": "Queen",
        "album": "Jazz (Deluxe Edition)",
        "duration": "3:29",
        "url": "https://music.apple.com/us/album/dont-stop-me-now/6781079346?i=6781079518"
      },
      {
        "id": "209710860",
        "title": "She Bangs (English Version)",
        "artist": "Ricky Martin",
        "album": "Sound Loaded",
        "duration": "4:40",
        "url": "https://music.apple.com/us/album/she-bangs-english-version/209710732?i=209710860"
      },
      {
        "id": "1440677665",
        "title": "Livin' On a Prayer",
        "artist": "Bon Jovi",
        "album": "Greatest Hits: The Ultimate Collection (Deluxe Edition)",
        "duration": "4:10",
        "url": "https://music.apple.com/us/album/livin-on-a-prayer/1440677662?i=1440677665"
      },
      {
        "id": "1547968625",
        "title": "Trouble's Coming",
        "artist": "Royal Blood",
        "album": "Typhoons",
        "duration": "3:48",
        "url": "https://music.apple.com/us/album/troubles-coming/1547968624?i=1547968625"
      },
      {
        "id": "1440825626",
        "title": "Love Is a Long Road",
        "artist": "Tom Petty",
        "album": "Full Moon Fever",
        "duration": "4:07",
        "url": "https://music.apple.com/us/album/love-is-a-long-road/1440825367?i=1440825626"
      },
      {
        "id": "1161539476",
        "title": "Boulevard of Broken Dreams",
        "artist": "Green Day",
        "album": "American Idiot",
        "duration": "4:20",
        "url": "https://music.apple.com/us/album/boulevard-of-broken-dreams/1161539183?i=1161539476"
      },
      {
        "id": "1440851719",
        "title": "This Love",
        "artist": "Maroon 5",
        "album": "Songs About Jane",
        "duration": "3:27",
        "url": "https://music.apple.com/us/album/this-love/1440851650?i=1440851719"
      },
      {
        "id": "1440912354",
        "title": "No Sleep Till Brooklyn",
        "artist": "Beastie Boys",
        "album": "Licensed to Ill",
        "duration": "4:06",
        "url": "https://music.apple.com/us/album/no-sleep-till-brooklyn/1440912031?i=1440912354"
      },
      {
        "id": "395957041",
        "title": "Boyfriend",
        "artist": "Big Time Rush",
        "album": "BTR",
        "duration": "3:21",
        "url": "https://music.apple.com/us/album/boyfriend/395957018?i=395957041"
      },
      {
        "id": "277635828",
        "title": "I'm Yours",
        "artist": "Jason Mraz",
        "album": "We Sing. We Dance. We Steal Things",
        "duration": "4:02",
        "url": "https://music.apple.com/us/album/im-yours/277635758?i=277635828"
      },
      {
        "id": "715891620",
        "title": "I Kissed a Girl",
        "artist": "Katy Perry",
        "album": "One of the Boys",
        "duration": "2:59",
        "url": "https://music.apple.com/us/album/i-kissed-a-girl/715891425?i=715891620"
      },
      {
        "id": "275765380",
        "title": "Since U Been Gone",
        "artist": "Kelly Clarkson",
        "album": "Breakaway",
        "duration": "3:08",
        "url": "https://music.apple.com/us/album/since-u-been-gone/275765354?i=275765380"
      }
    ]
  },
  {
    "key": "don",
    "title": "Don",
    "color": "#8cc7a8",
    "size": 68,
    "src": "https://embed.music.apple.com/us/playlist/don/pl.u-vpbBI8YzK6p",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-001-Image000001/v4/06/bf/4c/06bf4c97-62b8-7909-52c3-442e018c0831/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "1587804194",
        "title": "Flocky Flocky (feat. Travis Scott)",
        "artist": "Don Toliver",
        "album": "Life of a DON",
        "duration": "3:03",
        "url": "https://music.apple.com/us/album/flocky-flocky-feat-travis-scott/1587804188?i=1587804194"
      },
      {
        "id": "1674872965",
        "title": "No Pole",
        "artist": "Don Toliver",
        "album": "Love Sick (Deluxe)",
        "duration": "3:07",
        "url": "https://music.apple.com/us/album/no-pole/1674872963?i=1674872965"
      },
      {
        "id": "1871258331",
        "title": "Body",
        "artist": "Don Toliver",
        "album": "OCTANE",
        "duration": "2:35",
        "url": "https://music.apple.com/us/album/body/1871258329?i=1871258331"
      },
      {
        "id": "1825697701",
        "title": "3am",
        "artist": "Loe Shimmy & Don Toliver",
        "album": "Rockstar Junkie",
        "duration": "2:16",
        "url": "https://music.apple.com/us/album/3am/1825697667?i=1825697701"
      },
      {
        "id": "1871258354",
        "title": "Excavator",
        "artist": "Don Toliver",
        "album": "OCTANE",
        "duration": "3:31",
        "url": "https://music.apple.com/us/album/excavator/1871258329?i=1871258354"
      },
      {
        "id": "1502319160",
        "title": "After Party",
        "artist": "Don Toliver",
        "album": "Heaven Or Hell",
        "duration": "2:47",
        "url": "https://music.apple.com/us/album/after-party/1502318851?i=1502319160"
      },
      {
        "id": "1753900453",
        "title": "KRYPTONITE",
        "artist": "Don Toliver",
        "album": "HARDSTONE PSYCHO",
        "duration": "3:02",
        "url": "https://music.apple.com/us/album/kryptonite/1753900450?i=1753900453"
      },
      {
        "id": "1492786008",
        "title": "HAD ENOUGH (feat. Quavo & Offset)",
        "artist": "Don Toliver",
        "album": "JACKBOYS",
        "duration": "2:37",
        "url": "https://music.apple.com/us/album/had-enough-feat-quavo-offset/1492785997?i=1492786008"
      },
      {
        "id": "1871258335",
        "title": "Tiramisu",
        "artist": "Don Toliver",
        "album": "OCTANE",
        "duration": "2:18",
        "url": "https://music.apple.com/us/album/tiramisu/1871258329?i=1871258335"
      },
      {
        "id": "1753900896",
        "title": "BANDIT",
        "artist": "Don Toliver",
        "album": "HARDSTONE PSYCHO",
        "duration": "2:27",
        "url": "https://music.apple.com/us/album/bandit/1753900450?i=1753900896"
      },
      {
        "id": "1871258356",
        "title": "Gemstone",
        "artist": "Don Toliver",
        "album": "OCTANE",
        "duration": "2:01",
        "url": "https://music.apple.com/us/album/gemstone/1871258329?i=1871258356"
      },
      {
        "id": "1657271966",
        "title": "Too Many Nights (feat. Don Toliver)",
        "artist": "Metro Boomin & Future",
        "album": "HEROES & VILLAINS",
        "duration": "3:19",
        "url": "https://music.apple.com/us/album/too-many-nights-feat-don-toliver/1657271960?i=1657271966"
      },
      {
        "id": "1753900675",
        "title": "TORE UP",
        "artist": "Don Toliver",
        "album": "HARDSTONE PSYCHO",
        "duration": "2:06",
        "url": "https://music.apple.com/us/album/tore-up/1753900450?i=1753900675"
      },
      {
        "id": "1657869488",
        "title": "Used (feat. Don Toliver)",
        "artist": "SZA",
        "album": "SOS",
        "duration": "2:26",
        "url": "https://music.apple.com/us/album/used-feat-don-toliver/1657869377?i=1657869488"
      },
      {
        "id": "1753900685",
        "title": "BROTHER STONE (FEAT. KODAK BLACK)",
        "artist": "Don Toliver",
        "album": "HARDSTONE PSYCHO",
        "duration": "3:22",
        "url": "https://music.apple.com/us/album/brother-stone-feat-kodak-black/1753900450?i=1753900685"
      }
    ]
  },
  {
    "key": "la-flame",
    "title": "La Flame",
    "color": "#729ddb",
    "size": 60,
    "src": "https://embed.music.apple.com/us/playlist/la-flame/pl.u-YWLRtD2PrGE",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-001-Image000001/v4/a9/52/ea/a952ea53-6179-b5c4-408f-f5e7b3eb590c/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "1150135949",
        "title": "guidance",
        "artist": "Travis Scott",
        "album": "Birds In The Trap Sing McKnight",
        "duration": "3:27",
        "url": "https://music.apple.com/us/album/guidance/1150135681?i=1150135949"
      },
      {
        "id": "1699712660",
        "title": "SKITZO (feat. Young Thug)",
        "artist": "Travis Scott",
        "album": "UTOPIA",
        "duration": "6:06",
        "url": "https://music.apple.com/us/album/skitzo-feat-young-thug/1699712635?i=1699712660"
      },
      {
        "id": "1763919913",
        "title": "Quintana Pt. 2",
        "artist": "Travis Scott",
        "album": "DAYS BEFORE RODEO",
        "duration": "3:06",
        "url": "https://music.apple.com/us/album/quintana-pt-2/1763919907?i=1763919913"
      },
      {
        "id": "1826343783",
        "title": "SHYNE",
        "artist": "Travis Scott & GloRilla",
        "album": "JACKBOYS 2",
        "duration": "3:13",
        "url": "https://music.apple.com/us/album/shyne/1826343589?i=1826343783"
      },
      {
        "id": "1456177232",
        "title": "Nightcrawler (feat. Swae Lee & Chief Keef)",
        "artist": "Travis Scott",
        "album": "Rodeo",
        "duration": "5:21",
        "url": "https://music.apple.com/us/album/nightcrawler-feat-swae-lee-chief-keef/1456176981?i=1456177232"
      },
      {
        "id": "1657271969",
        "title": "Trance",
        "artist": "Metro Boomin, Travis Scott & Young Thug",
        "album": "HEROES & VILLAINS",
        "duration": "3:14",
        "url": "https://music.apple.com/us/album/trance/1657271960?i=1657271969"
      },
      {
        "id": "1699712652",
        "title": "DELRESTO (ECHOES) [feat. Beyonc\u00e9]",
        "artist": "Travis Scott",
        "album": "UTOPIA",
        "duration": "4:34",
        "url": "https://music.apple.com/us/album/delresto-echoes-feat-beyonc%C3%A9/1699712635?i=1699712652"
      },
      {
        "id": "1826343593",
        "title": "KICK OUT",
        "artist": "Travis Scott",
        "album": "JACKBOYS 2",
        "duration": "2:50",
        "url": "https://music.apple.com/us/album/kick-out/1826343589?i=1826343593"
      },
      {
        "id": "1699712643",
        "title": "MODERN JAM (feat. Teezo Touchdown)",
        "artist": "Travis Scott",
        "album": "UTOPIA",
        "duration": "4:15",
        "url": "https://music.apple.com/us/album/modern-jam-feat-teezo-touchdown/1699712635?i=1699712643"
      },
      {
        "id": "1456177229",
        "title": "90210 (feat. Kacy Hill)",
        "artist": "Travis Scott",
        "album": "Rodeo",
        "duration": "5:39",
        "url": "https://music.apple.com/us/album/90210-feat-kacy-hill/1456176981?i=1456177229"
      },
      {
        "id": "1699712651",
        "title": "FE!N (feat. Playboi Carti)",
        "artist": "Travis Scott",
        "album": "UTOPIA",
        "duration": "3:11",
        "url": "https://music.apple.com/us/album/fe-n-feat-playboi-carti/1699712635?i=1699712651"
      },
      {
        "id": "1150135948",
        "title": "lose",
        "artist": "Travis Scott",
        "album": "Birds In The Trap Sing McKnight",
        "duration": "3:20",
        "url": "https://music.apple.com/us/album/lose/1150135681?i=1150135948"
      },
      {
        "id": "1699712656",
        "title": "CIRCUS MAXIMUS (feat. The Weeknd & Swae Lee)",
        "artist": "Travis Scott",
        "album": "UTOPIA",
        "duration": "4:18",
        "url": "https://music.apple.com/us/album/circus-maximus-feat-the-weeknd-swae-lee/1699712635?i=1699712656"
      },
      {
        "id": "1421243049",
        "title": "WAKE UP",
        "artist": "Travis Scott",
        "album": "ASTROWORLD",
        "duration": "3:51",
        "url": "https://music.apple.com/us/album/wake-up/1421241217?i=1421243049"
      },
      {
        "id": "1421243212",
        "title": "YOSEMITE",
        "artist": "Travis Scott",
        "album": "ASTROWORLD",
        "duration": "2:30",
        "url": "https://music.apple.com/us/album/yosemite/1421241217?i=1421243212"
      }
    ]
  },
  {
    "key": "cornrow-kenny",
    "color": "#4b7bec",
    "size": 44,
    "title": "Cornrow Kenny",
    "src": "https://embed.music.apple.com/us/playlist/cornrow-kenny/pl.u-PJxDIyKL02E",
    "artwork": "https://is1-ssl.mzstatic.com/image/thumb/SG-MQ-US-037-Image000001/v4/9d/1d/2e/9d1d2ee7-9193-0536-f6e4-b159b94e762d/image/400x400bb.jpg",
    "tracks": [
      {
        "id": "1471264138",
        "title": "Compton (feat. Dr. Dre)",
        "artist": "Kendrick Lamar",
        "album": "good kid, m.A.A.d city (Deluxe)",
        "duration": "4:08",
        "url": "https://music.apple.com/us/album/compton-feat-dr-dre/1471264092?i=1471264138"
      },
      {
        "id": "1440829895",
        "title": "i",
        "artist": "Kendrick Lamar",
        "album": "To Pimp a Butterfly",
        "duration": "5:36",
        "url": "https://music.apple.com/us/album/i/1440828886?i=1440829895"
      },
      {
        "id": "1440845054",
        "title": "untitled 08 l 09.06.2014.",
        "artist": "Kendrick Lamar",
        "album": "untitled unmastered.",
        "duration": "3:55",
        "url": "https://music.apple.com/us/album/untitled-08-l-09-06-2014/1440844834?i=1440845054"
      },
      {
        "id": "1744776350",
        "title": "meet the grahams",
        "artist": "Kendrick Lamar",
        "album": "meet the grahams - Single",
        "duration": "6:32",
        "url": "https://music.apple.com/us/album/meet-the-grahams/1744776349?i=1744776350"
      },
      {
        "id": "1440828906",
        "title": "Wesley's Theory (feat. George Clinton & Thundercat)",
        "artist": "Kendrick Lamar",
        "album": "To Pimp a Butterfly",
        "duration": "4:47",
        "url": "https://music.apple.com/us/album/wesleys-theory-feat-george-clinton-thundercat/1440828886?i=1440828906"
      },
      {
        "id": "1440881805",
        "title": "FEAR.",
        "artist": "Kendrick Lamar",
        "album": "DAMN.",
        "duration": "7:40",
        "url": "https://music.apple.com/us/album/fear/1440881047?i=1440881805"
      },
      {
        "id": "1443063993",
        "title": "No More Parties in LA",
        "artist": "Kanye West",
        "album": "The Life of Pablo",
        "duration": "6:14",
        "url": "https://music.apple.com/us/album/no-more-parties-in-la/1443063578?i=1443063993"
      },
      {
        "id": "1471264101",
        "title": "Poetic Justice (feat. Drake)",
        "artist": "Kendrick Lamar",
        "album": "good kid, m.A.A.d city (Deluxe)",
        "duration": "5:00",
        "url": "https://music.apple.com/us/album/poetic-justice-feat-drake/1471264092?i=1471264101"
      },
      {
        "id": "1744024751",
        "title": "euphoria",
        "artist": "Kendrick Lamar",
        "album": "euphoria - Single",
        "duration": "6:23",
        "url": "https://music.apple.com/us/album/euphoria/1744024729?i=1744024751"
      },
      {
        "id": "1440906939",
        "title": "All The Stars",
        "artist": "Kendrick Lamar, SZA",
        "album": "Black Panther: The Album",
        "duration": "3:52",
        "url": "https://music.apple.com/us/album/all-the-stars/1440906927?i=1440906939"
      },
      {
        "id": "1440881693",
        "title": "LUST.",
        "artist": "Kendrick Lamar",
        "album": "DAMN.",
        "duration": "5:07",
        "url": "https://music.apple.com/us/album/lust/1440881047?i=1440881693"
      },
      {
        "id": "1781270549",
        "title": "heart pt. 6",
        "artist": "Kendrick Lamar",
        "album": "GNX",
        "duration": "4:52",
        "url": "https://music.apple.com/us/album/heart-pt-6/1781270319?i=1781270549"
      },
      {
        "id": "1316706682",
        "title": "Dedication (feat. Kendrick Lamar)",
        "artist": "Nipsey Hussle",
        "album": "Victory Lap",
        "duration": "4:05",
        "url": "https://music.apple.com/us/album/dedication-feat-kendrick-lamar/1316706552?i=1316706682"
      },
      {
        "id": "1440829879",
        "title": "The Blacker the Berry",
        "artist": "Kendrick Lamar",
        "album": "To Pimp a Butterfly",
        "duration": "5:28",
        "url": "https://music.apple.com/us/album/the-blacker-the-berry/1440828886?i=1440829879"
      },
      {
        "id": "1440844989",
        "title": "untitled 07 l 2014 - 2016",
        "artist": "Kendrick Lamar",
        "album": "untitled unmastered.",
        "duration": "8:16",
        "url": "https://music.apple.com/us/album/untitled-07-l-2014-2016/1440844834?i=1440844989"
      }
    ]
  }
];

export default musicPlaylists;
